import { Routes, Route } from "react-router-dom";
import { Page } from ".";

export const SignUpRouter = (): JSX.Element => (
  <Routes>
    <Route path="/*" element={<Page variant="root" />} />
    <Route path="/confirm/*" element={<Page variant="confirm" />} />
    <Route path="sent" element={<Page variant="sent" />} />
    <Route path="welcome" element={<Page variant="welcome" />} />
    <Route path="account-confirmed" element={<Page variant="account-confirmed" />} />
    <Route path="user-account-confirmed" element={<Page variant="user-account-confirmed" />} />
  </Routes>
);
